<template>
  <div class="ai-assessment-container">
    <!-- 与 homemain1.vue AI 研判区域结构一致 -->
    <div class="ai-inner transition">
      <textarea
        v-model="inputAddress"
        class="ai-textarea"
        :placeholder="$t('components.aiAssessment.placeholder')"
        ref="addressInput"
      ></textarea>

      <div
        v-if="inputAddress"
        @click="inputAddress = ''"
        class="ai-btn-clear transition"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
          />
        </svg>
      </div>

      <div class="flex justify-between items-center" style="margin-top: 8px">
        <el-tooltip
          :content="$t('components.aiAssessment.tooltips.historicalRecords')"
          placement="top"
          popper-class="custom-action-tooltip"
          :open-delay="200"
        >
          <button class="ai-action-btn transition" @click="historicalRecords">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </button>
        </el-tooltip>

        <button
          class="ai-submit-btn transition"
          :class="{ 'has-content': inputAddress.trim() !== '' }"
          @click="sendAnalysisRequest"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="18" cy="5" r="3"></circle>
            <circle cx="6" cy="12" r="3"></circle>
            <circle cx="18" cy="19" r="3"></circle>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
          </svg>
        </button>
      </div>
    </div>
    <!-- AI 建议按钮 - 与 homemain1.vue ai-suggestion-box 一致 -->
    <!-- <div class="flex gap-3 ai-suggestion-box">
      <button class="ai-suggestion transition" @click="fillExample1">
        {{ $t("components.aiAssessment.examples.example1") }}
      </button>
      <button class="ai-suggestion transition" @click="fillExample2">
        {{ $t("components.aiAssessment.examples.example2") }}
      </button>
    </div> -->

    <DialogHistory
      :visible.sync="showHistoryDialog"
      @updateVisible="updateVisible"
      @getMessageList="getMessageList"
    />
  </div>
</template>

<script>
import DialogHistory from "@/views/newtheme/newhome/DialogHistory.vue";

export default {
  components: {
    DialogHistory
  },
  data() {
    return {
      showHistoryDialog: false,
      inputAddress: ""
    };
  },
  methods: {
    //获取某一个会话的具体会话内容
    getMessageList(item) {
      console.log("会话id");
      console.log(item);
      //  conversationId:
      this.analyzeAddress(item);
    },
    // 打开对话记录
    historicalRecords() {
      console.log("执行");
      // this.$emit("historicalRecords", true);
      this.showHistoryDialog = true;
    },
    updateVisible() {
      this.showHistoryDialog = false;
    },
    // 处理删除历史记录
    // handleDelete(item) {
    //   const index = this.historyList.findIndex(
    //     (record) => record.id === item.id
    //   );
    //   if (index !== -1) {
    //     this.historyList.splice(index, 1);
    //   }
    // },

    analyzeAddress(item) {
      //对话记录跳转
      if (item) {
        console.log("打印");

        console.log(item);
        let surveySuggest = {
          conversationId: item.conversationId,
          canvasid: item.canvasId ? item.canvasId : null,
          branchId: item.branchId ? item.branchId : null,
          title: item.title || null,
          id: null
        };
        sessionStorage.surveySuggest = JSON.stringify(surveySuggest);

        // 构建 query 参数，只添加有值的字段
        const query = {
          temporarilycanvas: true,
          conversationId: item.conversationId
        };

        // 只有当值存在且不为 null 时才添加到 query
        if (item.canvasId) {
          query.id = item.canvasId;
        }
        if (item.branchId) {
          query.branchId = item.branchId;
        }

        let caseAnalysisone = this.$router.resolve({
          path: "/AIcanvas",
          query: query
        });
        window.openByAnchor(caseAnalysisone.href, "_blank");
      } else {
        // 分析地址的方法
        console.log("分析内容:", this.inputAddress);
        if (this.inputAddress == "") {
          return;
        }

        let caseAnalysisone = this.$router.resolve({
          path: "/AIcanvas",
          query: {
            temporarilycanvas: true,
            // addresslist: JSON.stringify({
            //   dealaddress: "0xa57bd00134b2850b2a1c55860c9e9ea100fdd6cf",
            // }),
            inputContent: JSON.stringify(this.inputAddress)
          }
        });
        window.openByAnchor(caseAnalysisone.href, "_blank");
      }
    },
    sendAnalysisRequest() {
      // 发送分析请求
      console.log("发送分析请求");
      this.analyzeAddress();
    },
    fillExample1() {
      this.inputAddress = this.$t(
      "components.aiAssessment.examples.fullExample1");

      this.$nextTick(() => {
        this.sendAnalysisRequest();
      });
    },
    fillExample2() {
      this.inputAddress = this.$t(
      "components.aiAssessment.examples.fullExample2");

      this.$nextTick(() => {
        this.sendAnalysisRequest();
      });
    }
  }
};</script>

<style lang="less" scoped>
@import "@/assets/css/newhomepage/ai-assessment.less";
</style>
<style lang="less">
/* Element 弹层/弹窗/Tooltip 挂载在 body，需全局样式 */
@import "@/assets/css/newhomepage/homemain-common.less";
// ::v-deep .el-tooltip__popper.is-dark {
//   border-radius: 16px !important;
// }
</style>
